<template>
  <div>
    <!-- <h2>Legenda</h2> -->

    <p>
      Krajské hygienické stanice na základě oznámení o konání zotavovací akce
      vedou evidenci tzv. letních dětských táborů. Informace o zotavovací akci
      vkládají do informačního systému Registr HDM, ve kterém jsou dále
      evidovány i výsledky státního zdravotního dozoru na zotavovacích akcích.
    </p>

    <p>
      Na těchto stránkách jsou v mapových podkladech zveřejněny lokality, kde se
      letní dětské tábory konají. V informační bublině ke každému táboru jsou
      uvedeny informace o názvu zotavovací akce, místu jejího konání, pořadateli
      akce, způsobu zásobování pitnou vodou a zajištění stravování dětí. Další
      informace jsou o splnění ohlašovací povinnost pořadatelem tábora, termínu
      konání tábora a počtu rekreovaných dětí.
    </p>

    <p>
      V případě, že na táboře byla pracovníky KHS provedena kontrola, je uveden
      termín výkonu státního zdravotního dozoru a pokud nebyly zjištěny závady,
      tak je tábor označen :-)
    </p>
    <p>
      Protože ohlašování táborů dostávají krajské hygienické stanice postupně
      před zahájením letní sezony a také v jejím průběhu, jsou v mapě zveřejněny
      i lokality, kde se akce konaly i v minulé letní sezoně.
    </p>

    <p>
      Na jedné lokalitě může probíhat i více táborů, pořadatele jednotlivých
      akcí lze vybrat listováním v informačním panelu po kliknutí na ikonu v
      mapě.
    </p>

    <p>
      Hygienická služba poskytuje z registru HDM informace o letních dětských
      táborech, ale také o školách v přírodě, jiných podobných akcích, o zimních
      zotavovacích akcích i hasičskému záchrannému sboru, které slouží jako
      podklady při řešení mimořádných klimatických situací (povodně, přívalové
      srážky, vichřice a pod).
    </p>

    <ul>
      <li>
        <img
          src="@/assets/zotavovaci-letos.png"
          width="25"
          height="25"
          alt="Zotavovací akce (aktuální sezóna)"
        />
        Zotavovací akce (aktuální sezóna)
      </li>
      <li>
        <img
          src="@/assets/zotavovaci-loni.png"
          width="25"
          height="25"
          alt="Zotavovací akce (loňská sezóna)"
        />
        Zotavovací akce (loňská sezóna)
      </li>
      <li>
        <img
          src="@/assets/jine-letos.png"
          width="25"
          height="25"
          alt="Jiná podobná akce (aktuální sezóna)"
        />
        Jiná podobná akce (aktuální sezóna)
      </li>
      <li>
        <img
          src="@/assets/jine-loni.png"
          width="25"
          height="25"
          alt="Jiná podobná akce (loňská sezóna)"
        />
        Jiná podobná akce (loňská sezóna)
      </li>
      <!-- <li>
        <img src="@/assets/jina_letosni.svg" alt="Oblast s větším počtem táborů" />
        Oblast s větším počtem táborů
      </li> -->
    </ul>
  </div>
</template>

<script>
export default {
  mounted() {
    this.$emit("caption", "Legenda");
  }
};
</script>

<style scoped>
.side-legend span:first-child {
  display: inline-block;
  width: 1em;
  height: 1em;
  margin-right: 0.8em;
  -webkit-box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  -moz-box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
  box-shadow: 0 0 2px rgba(0, 0, 0, 0.5);
}

.side-legend span {
  vertical-align: middle;
}

ul {
  padding-left: 5px;
  /*padding: 0;*/
  list-style-type: none;
}
</style>
